<template>
    <div :class="classList">
        <input
            :id="inputConfig.id"
            :name="inputConfig.name"
            :class="inputConfig.styleClass"
            :type="inputConfig.type"
            :maxlength="inputConfig.maxlength"
            @blur="handleBlur($event)"
            @focus="handleFocus($event)"
            ref="universityInput"
            autocomplete="off"
            :tabindex="inputConfig.tabIndex" />
        <label :class="{ floated: floatLabel }" :for="inputConfig.id">
            {{ inputConfig.label }}
        </label>
        <div class="university-dropdown" ref="div-list">
            <div
                v-for="field in this.options"
                class="university-item"
                @click="selectOrg(field.name, field.id)">
                {{ field.name }}
            </div>
        </div>
    </div>
</template>

<script>
    import HttpService from '../services/HttpService';
    import { AA_XHR_BASE_PATH } from '../vue/constants/svodRoutes';
    import debounce from 'lodash/debounce';

    export default {
        name: 'LabelInputSheerID',
        props: {
            inputConfig: {
                type: Object,
                required: true,
            },
            errorMessage: {
                type: String,
                required: false,
                default: '',
            },
        },
        data: function () {
            return {
                debounceCallback: debounce(this.handleInput, 500),
                options: [],
                focused: false,
                hasInput: false,
                http: new HttpService(),
            };
        },

        computed: {
            floatLabel() {
                return this.focused || this.hasInput;
            },

            classList: function () {
                let list = ['field-wrapper', 'field-wrapper--floating-label'];

                if (typeof this.inputConfig.name === 'string') {
                    list.push(`field-wrapper--${this.inputConfig.name}`);
                }

                if (this.focused) list.push('focused');
                if (this.errorMessage) list.push('error');

                return list;
            },
        },
        mounted() {
            this.$refs['universityInput'].addEventListener('keyup', this.debounceCallback);
        },
        methods: {
            selectOrg(name, id) {
                this.options = [];
                this.hasInput = true;
                this.$emit('input', {
                    name: 'name',
                    value: name,
                });
                this.$emit('input', {
                    name: 'university',
                    value: id,
                });
                this.$refs.universityInput.value = name;
            },
            handleInput() {
                // We don't want to run queries on extremely short inputs - min 3 characters.
                if (this.$refs.universityInput.value.length > 2) {
                    this.http
                        .doGet(
                            `${AA_XHR_BASE_PATH}edu-search/?name=${this.$refs.universityInput.value}`,
                            null,
                        )
                        .then((resp) => {
                            this.options = [];
                            if (
                                resp &&
                                resp.data &&
                                resp.success === true &&
                                Array.isArray(resp.data.result)
                            ) {
                                this.options = resp.data.result;
                            }
                        })
                        .catch((err) => {
                            console.log('eduSearch : resp error : ', err);
                        });
                }
            },
            handleFocus() {
                this.focused = true;
                this.$emit('focus', {
                    name: this.inputConfig.name,
                    value: this.$refs.universityInput.value,
                });
            },

            handleBlur($e) {
                this.focused = false;
                this.hasInput =
                    typeof $e.target.value === 'string' && $e.target.value.trim().length > 0;
                this.$emit('blur', {
                    value: this.$refs.universityInput.value,
                });
            },
        },
    };
</script>
